<template lang="pug">
.banner.w-full.h-auto
  swiper-container.banner(ref="bannerSwiper", class="landscape:xl:h-full", :modules="[Autoplay]", :loop="canSlide", autoplay-delay="2500", autoplay-disable-on-interaction="false", autoplay-pause-on-interaction="false", autoplay-stop-on-interaction="false", :navigation="false", :pagination="false", lazy="true")
    swiper-slide.gtm-activity-item.flex.justify-center.h-auto(v-for="banner in list", :key="banner.activityNo", :class="[redirect ? 'cursor-pointer' : '', 'portrait:aspect-[5/2]']", data-location="ad", :data-activity-no="banner.activityNo", :data-template="banner.template", :data-activity-name="banner.name", :data-activity-type-name="banner.activityTypeName")
      img.w-auto.h-full.object-contain(:src="bannerImg(banner)", :alt="getTitle(banner)", loading="lazy")
</template>

<script setup>
import { Autoplay } from 'swiper/modules'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

import { useNuxtApp } from '#app'
import { useLocaleSetting } from '@/composables/core/useLocaleSetting'
import { useMainStore } from '@/stores/main'

const props = defineProps({
  redirect: {
    type: Boolean,
    default: true,
  },
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'carouselUrl',
  },
  pagination: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['showCustomerService'])

const COMPONENT_NAME = 'Banner'

const { $analytics, $openWithIframeFallback } = useNuxtApp()
const store = useMainStore()
const { setModalParams, setTrackLocation, setModal } = store
const { getCdnUrl } = useCdnAssets()
const { getFromActivity, shouldFilter } = useLocaleSetting()
const bannerSwiper = ref(null)

// 只有多於一張輪播圖時才啟用 Swiper loop：slide 數不足時 loop 會觸發 loopCreate
// 複製／搬移 DOM 節點，與 Vue 的 patch 產生衝突（CLIENT-PWA-SSR-C2/C3/C1，#322）
const canSlide = computed(() => props.list.length > 1)

onMounted(() => {
  bannerSwiper.value.swiper.on('click', handleClick)
})

onBeforeUnmount(() => {
  bannerSwiper.value?.swiper.off('click', handleClick)
})

const bannerImg = (banner) => {
  if (shouldFilter(banner)) {
    return getCdnUrl(getFromActivity(banner, props.type))
  }
  return getCdnUrl(banner?.[props.type]?.[0]?.url || '')
}

const getTitle = (banner) => {
  return getFromActivity(banner, 'title')
}

// 取得輪播圖點擊後目標
const getCarouselUrl = (item) => {
  if (item.externalLink) {
    $openWithIframeFallback(item.externalLink)
  } else if (item.serviceButtonEnable === 1) {
    emit('showCustomerService')
  }
}

const handleClick = (s, e) => {
  const activityTarget = props.list.find(({ activityNo }) => activityNo === e.target.dataset.activityNo)
  if (activityTarget && activityTarget.displayMode === 'carouselImage') {
    getCarouselUrl(activityTarget)
  } else if (props.redirect) {
    const activityNo = e.target.dataset.activityNo
    const template = e.target.dataset.template
    const activityName = e.target.dataset.activityName
    const activityTypeName = e.target.dataset.activityTypeName

    $analytics.push({
      event: 'activity_click',
      location: 'ad',
      activityNo: activityNo,
      template: template,
      activityName: activityName,
      icon: `${template}|${activityName}`,
      component_name: COMPONENT_NAME,
    })
    setModalParams({ typeName: activityTypeName, id: activityNo })
    setTrackLocation(`Banner|${activityName}`)
    setModal('ModalMission')
  }
}
</script>

<style lang="scss">
.banner {
  .swiper-container {
    z-index: 0;
  }
}
</style>
